import _axios from "../../apiClient";

export function GetAllNiveles() {
  return _axios
    .get(`/api/Nivel/GetAllNiveles`, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("Error en la petición de Nivel:", error);
      const data = error.response.data;
      throw data;
    });
}

export function getNivel(idNivel) {
  return _axios
    .get(`/api/Nivel/GetNivelById/${idNivel}`, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function getNivelByCodigo(nroNivel) {
  return _axios
    .get(`/api/Nivel/GetNivelesUsuariolByNro`, {
      params: { nroNivel },
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function getNivelByNombre(descripcion) {
  return _axios
    .get(`/api/Nivel/GetNivelesUsuariolByDescripcion`, {
      params: { descripcion },
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function saveNivel(payload) {
  return _axios
    .post(`/api/Nivel/SaveNivel`, payload, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw data;
    });
}

export function deleteNivel(idNivel) {
  return _axios
    .delete(`/api/Nivel/DeleteNivel/${idNivel}`, {
      headers: { "Content-Type": "application/json;charset=UTF-8" },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw new Error(data.message || "Ocurrió un error al eliminar el nivel.");
    });
}
